import React, { createContext, useContext, useState, useEffect } from "react";
import { t } from "../mock/mock";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("haas_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("haas_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((p) => (p === "tr" ? "en" : "tr"));

  // helper to resolve {en, tr} objects or plain strings
  const tr = (val) => {
    if (val == null) return "";
    if (typeof val === "string") return val;
    return val[lang] ?? val.en ?? "";
  };

  const value = { lang, setLang, toggle, tr, ui: t[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
